import React from 'react';
import { Box, Typography, Card, Grid, Alert, AlertTitle } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';

export const TabReglas = ({ resumen }: { resumen: any }) => {
    const data = resumen?.rulesMetrics || { totalAlerts: 0, alertsByLevel: [], alertsByArea: [] };
    
    const colors = ['#f44336', '#FF9800', '#4CAF50']; // Alto, Medio, Bajo

    return (
        <Grid container spacing={3}>
            {/* Mensaje Explicativo */}
            <Grid size={{xs: 12}}>
                <Alert severity="info" sx={{ borderRadius: 3, mb: 1, '& .MuiAlert-message': { width: '100%' } }}>
                    <AlertTitle sx={{ fontWeight: 800 }}>¿Por qué son importantes estas alertas?</AlertTitle>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                            <strong>Prevención de crisis:</strong> Monitorea en tiempo real las alertas de riesgo disparadas por bajas calificaciones.
                        </Typography>
                        <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                            <strong>Gestión de equipos:</strong> Evalúa la eficiencia de resolución viendo el porcentaje de casos Cerrados vs Pendientes.
                        </Typography>
                        <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
                            <strong>Focos rojos por Área:</strong> Descubre qué departamentos están generando más alertas y si están logrando gestionarlas o se les están acumulando, permitiéndote tomar acciones correctivas inmediatas.
                        </Typography>
                    </Box>
                </Alert>
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Card sx={{ p: 3, borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.03)', border: '1px solid #f0f0f0', height: '100%' }}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#2e263d', mb: 1 }}>Alertas por Nivel</Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
                        Distribución de las alertas generadas según su nivel de prioridad.
                    </Typography>
                    <Box sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <PieChart
                            series={[
                            {
                                data: data.alertsByLevel.map((a: any, i: number) => ({ id: i, value: a.count, label: a.level, color: colors[i] })),
                                innerRadius: 40,
                                outerRadius: 100,
                                paddingAngle: 2,
                                cornerRadius: 3,
                            }
                            ]}
                            height={300}
                            slotProps={{
                                legend: { direction: 'horizontal', position: { vertical: 'bottom', horizontal: 'center' } }
                            }}
                        />
                    </Box>
                </Card>
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Card sx={{ p: 3, borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.03)', border: '1px solid #f0f0f0', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Box sx={{ textAlign: 'center', mb: 3 }}>
                        <Typography variant="h2" sx={{ fontWeight: 900, color: '#4A148C' }}>{data.totalAlerts}</Typography>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.secondary' }}>Total de alertas disparadas</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 2 }}>
                        <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="h4" sx={{ fontWeight: 800, color: '#5DCC0A' }}>{data.resolvedAlerts}</Typography>
                            <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary' }}>Resueltas</Typography>
                        </Box>
                        <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="h4" sx={{ fontWeight: 800, color: '#FF9800' }}>{data.pendingAlerts}</Typography>
                            <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary' }}>Pendientes</Typography>
                        </Box>
                    </Box>
                </Card>
            </Grid>

            {/* Alertas por Área */}
            <Grid size={{xs: 12}}>
                <Card sx={{ p: 3, borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.03)', border: '1px solid #f0f0f0' }}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#2e263d', mb: 1 }}>Estado de Alertas por Área</Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
                        Porcentaje de alertas resueltas vs pendientes para cada área (suma el 100% de alertas de dicha área).
                    </Typography>
                    <Box sx={{ height: 350 }}>
                        <BarChart
                            dataset={data.alertsByArea || []}
                            layout="horizontal"
                            yAxis={[{ scaleType: 'band', dataKey: 'area', tickLabelStyle: { fontSize: 11, fontWeight: 600 } }]}
                            series={[
                                { dataKey: 'resolvedPercentage', label: 'Resueltas %', color: '#5DCC0A', stack: 'total' },
                                { dataKey: 'pendingPercentage', label: 'Pendientes %', color: '#FF9800', stack: 'total' }
                            ]}
                            height={350}
                            margin={{ left: 320, right: 30, top: 20, bottom: 30 }}
                        />
                    </Box>
                </Card>
            </Grid>
        </Grid>
    );
};
